<template>
  <div style="transform: none">
    <dp-side-options></dp-side-options>

    <div class="container" data-scroll-container>
      <div class="title-box">
        <div class="title-text">
          <div class="title-name">可信AI智能网关</div>
          <div class="title-desc">一个网关，安全接入全球大模型</div>
        </div>
        <img class="title-pic" :src="require('@/assets/maas/maas.png')"/>
      </div>
      <div class="main-region">
        <div class="module-title">
          <img :src="require('@/assets/maas/core.png')" class="module-icon"/>
          <span class="module-text">三大核心能力</span>
        </div>
        <div class="core-item" v-for="item in coreAbility" :key="item.id">
          <div class="core-name">{{item.title}}</div>
          <div class="core-desc">{{item.desc}}</div>
          <div class="core-advantage">
            <div class="core-advantage-single" v-for="single in item.list" :key="single">{{single}}</div>
          </div>
        </div>
        <div class="module-gap"></div>
        <div class="module-title">
          <img :src="require('@/assets/maas/matrix.png')" class="module-icon"/>
          <span class="module-text">模型能力矩阵</span>
          <span class="module-statement">覆盖国内主流大模型，满足各类业务场景需求</span>
        </div>
        <div class="ability-item" v-for="item in matrixList" :key="'matrix' + item.id" :class="{'ability-item-first': item.id === 1}">
          <div class="model-type">{{item.name}}</div>
          <div class="model-represent" :class="{'model-represent-first': item.id === 1}">{{item.represent}}</div>
          <div class="core-ability">{{item.core}}</div>
          <div class="typical-scene">{{item.scene}}</div>
        </div>
      </div>
      <div class="summary">
        <div class="summary-list">
          <div class="summary-item">
            <div class="summary-number">30+</div>
            <div class="summary-text">大模型服务商</div>
          </div>
          <div class="summary-item">
            <div class="summary-number">9 类</div>
            <div class="summary-text">用户画像分析</div>
          </div>
          <div class="summary-item">
            <div class="summary-number">4 项</div>
            <div class="summary-text">核心性能指标</div>
          </div>
          <div class="summary-item">
            <div class="summary-number">1 套</div>
            <div class="summary-text">统一 API 接口</div>
          </div>
        </div>
        <div class="summary-desc">让每一次&nbsp;Al&nbsp;调用，安全&nbsp;透明&nbsp;有据可查</div>
      </div>
      <system-identify></system-identify>
      <dp-footer></dp-footer>
    </div>

  </div>
</template>
<script>
import scroller from "../components/mixins/scroller";
import  systemIdentify from "@/components/systemIdentify.vue";

export default {
  mixins: [scroller],
  components: {
    systemIdentify
  },
  data() {
    return {
      matrixList:[
        {
          id:1,
          name:"模型分类",
          represent:"代表模型",
          core: "核心能力",
          scene: "典型场景"
        },
        {
          id:2,
          name:"旗舰推理",
          represent:"GLM-5.3 / GLM-5.2 / DeepSeek-V4-Pro / Qwen3.7-Max / MiniMax-M3",
          core: "深度推理、复杂分析",
          scene: "科研、代码、决策"
        },
        {
          id:3,
          name:"主力通用",
          represent:"GLM-5.1 / Qwen3.7-Plus / MiniMax-M2.5 / DeepSeek-V3.2",
          core: "性价比最优、通用场景",
          scene: "日常办公、内容生成"
        },
        {
          id:4,
          name:"高速轻量",
          represent:"GLM-5-Turbo / DeepSeek-V4-Flash / Qwen3.5-Plus / MiniMax-M2",
          core: "低延迟、高吞吐",
          scene: "客服、分类、摘要"
        },
        {
          id:5,
          name:"多模态",
          represent:"GLM-4V-Flash / Qwen3-VL / MiniMax-Hailuo / DeepSeek-VL2",
          core: "图文理解、视频分析",
          scene: "OCR、图表分析"
        },
        {
          id:6,
          name:"专项能力",
          represent:"Embedding / Reranker / TTS / STT",
          core: "向量化、重排、语音",
          scene: "RAG、语音交互"
        }
      ],
      coreAbility:[
        {
          id:1,
          title:"01  统一接入 · 一码通全球",
          desc: "OpenAl / Claude/Gemini    等30+服务商， 一套 API 全打通；智能路由、负载均衡、故障自动切换。",
          list: ["统一接口", "智能路由", "精细计费","多租户管理","全协议支持"]
        },
        {
          id:2,
          title:"02  智能洞察 · 师生画像可视",
          desc: "用户总览看板+交互回放时间轴+自动生成多维度画像，用量、成本、偏好、时段一屏掌握。",
          list: ["7日总览", "交互回放", "关键词检索","9类画像卡片"]
        },
        {
          id:3,
          title:"03  全场景监控 · 状态实时可见",
          desc: "RPM/TPM/TTFT/TPOT 四大核心指标趋势图，灵活时间粒度与多维筛选，异常第一时间发现。",
          list: ["四大指标", "峰值/均值", "1小时/24小时/7天","按用户 ·密钥 ·模型"]
        }
      ]
    };
  },
  mounted() {
    window.onresize = () => {
      setTimeout(() => {
        if (window.$scroller) {
          window.$scroller.update();
        }
      }, 1000);
    };
  },
  methods: {
  }

};
</script>
<style lang="less" scoped>
@font-face {
  font-family: 'YouSheBiaoTiHei';
  src: url('../assets/assetsNewImg/solution/YouSheBiaoTiHei-2.ttf');
}

@font-face {
  font-family: 'Judson';
  src: url('../assets/maas/judson-gm9r.ttf');
}

.title-box {
  background-image: url(../assets/assetsNewImg/solution/title-bg.png);
  background-size: 100%;
  height: 424px;
  display: flex;
  position: relative;
  .title-text {
    margin-top: 146px;
    margin-left: 163px;
    .title-name {
      font-family: OPPOSans;
      font-size: 40px;
      color: #224895;
    }

    .title-desc {
      font-family: OPPOSans;
      font-size: 20px;
      line-height: 32px;
      width: 711px;
      margin-top: 24px;
    }
  }
  .title-pic {
    width: 457px;
    height: 382px;
    position: absolute;
    left: 1248px;
    top: 21px;
  }
}
.main-region {
  padding: 122px 163px;
  .module-title {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    .module-icon {
      width: 27px;
      margin-right: 15px;
    }
    .module-text {
      font-size: 32px;
      line-height: 46px;
      color: #000;
      font-family: OPPOSans;
    }
    .module-statement {
      font-size: 16px;
      line-height: 23px;
      align-self: flex-end;
      margin-left: 45px;
      padding-bottom: 5px;
    }
  }
  .module-gap {
    height: 78px;
  }
  .core-item {
    height: 221px;
    background-color: #EDF5FF;
    border-radius: 12px;
    box-sizing: border-box;
    padding-top: 36px;
    padding-left: 40px;
    font-family: OPPOSans;
    .core-name {
      font-size: 24px;
      line-height: 34px;
      color: #224895;
    }
    .core-desc {
      font-size: 16px;
      line-height: 23px;
      margin-top: 25px;
    }
    .core-advantage {
      margin-top: 23px;
      display: flex;
      flex-wrap: wrap;
      .core-advantage-single {
        box-shadow: 0 0.93px 23.21px 0 #00FFFF40 inset;
        background: #2C64CC99;
        border-radius: 12px;
        display: inline-block;
        height: 37px;
        line-height: 37px;
        font-size: 16px;
        color: #fff;
        padding: 0 23px;
      }
      .core-advantage-single + .core-advantage-single {
        margin-left: 13px;
      }
    }
  }
  .core-item + .core-item {
    margin-top: 23px;
  }
  .ability-item {
    background: #E0EBFF99;
    height: 141px;
    box-sizing: border-box;
    border-radius: 12px;
    padding-left: 60px;
    display: flex;
    font-size: 16px;
    line-height: 26px;
    div {
      height: 100%;
      display: flex;
      align-items: center;
      padding-right: 10px;
      word-break: break-all;
      font-family: OPPOSans;
    }
    .typical-scene {
      width: 18.4%;
    }
    .core-ability {
      width: 22.2%;
    }
    .model-represent {
      width: 40%;
      font-family: "Judson";
    }
    .model-represent-first {
      font-family: OPPOSans;
    }
    .model-type {
      flex: 1;
      min-width: 0;
    }
  }
  .ability-item-first {
    background: #3261B899;
    height: 70px;
    font-size: 22px;
    color: #fff;
    font-family: OPPOSans;
  }
  .ability-item + .ability-item {
    margin-top: 8px;
  }
}
.summary {
  height: 509px;
  background-image: url(../assets/maas/summary.png);
  background-size: 100%;
  background-repeat: no-repeat;
  box-sizing: border-box;
  padding-top: 91px;
  .summary-list {
    display: flex;
    justify-content: center;
    .summary-item {
      width: 338px;
      height: 186px;
      border-radius: 24px;
      background-color: #224895;
      box-sizing: border-box;
      padding-top: 36px;
      text-align: center;
      font-family: OPPOSans;
      color: #fff;
      .summary-number {
        font-size: 42px;
        line-height: 60px;
      }
      .summary-text {
        margin-top: 15px;
        font-size: 24px;
        line-height: 34px;
        opacity: 0.7;
      }
    }
    .summary-item + .summary-item {
      margin-left: 10px;
    }
  }
  .summary-desc {
    font-size: 36px;
    line-height: 52px;
    text-align: center;
    color: #224895;
    margin-top: 87px;
  }
}
</style>
